import React from 'react'
import MaterialSymbol from '../material-symbol'

const Public = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="public" {...props} />
))

Public.displayName = 'Public'

export default Public
